import { attr } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

class UserBootstrap extends ShModel {
  @attr('string') intercomHash;
  @attr('date') companyCreatedAt;
  @attr('number') verifiedProjects;
  @attr('number') pendingVerification;
  @attr('boolean') isInvited;
  @attr('boolean') isReferred;
}

export default UserBootstrap;
